// extracted by mini-css-extract-plugin
export var acitonButtons = "_h7-0";
export var additionalIcon = "_h7-f";
export var block = "_h7-1";
export var blockContent = "_h7-7";
export var blockDescription = "_h7-8";
export var blockIcon = "_h7-9";
export var blockTitle = "_h7-6";
export var border = "_h7-a";
export var center = "_h7-l";
export var edge = "_h7-b";
export var edgeLabel = "_h7-c";
export var edgePath = "_h7-d";
export var error = "_h7-e";
export var flowchart = "_h7-g";
export var flowchartContent = "_h7-h";
export var highlighted = "_h7-3";
export var hover = "_h7-4";
export var icon = "_h7-i";
export var left = "_h7-m";
export var navButton = "_h7-j";
export var navButtons = "_h7-k";
export var right = "_h7-n";
export var selected = "_h7-2";
export var small = "_h7-5";